
























import { Component, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertMessage, bibliographySetApi, ErrorMessage } from '@/api'
import { setErrorMessage } from '@/utils/error'
import {
  AutoOrderTable,
  AutoOrderTableItem,
  AutoOrderTableItemRow,
  defaultAutoOrderTableItem
} from '@/components/organisms/AutoOrderTable'
import {
  CallNumberEditItem,
  ModalCallNumberEdit
} from '@/components/modals/ModalCallNumberEdit'
import { cloneDeep } from 'lodash'

interface ModalAutoOrderBulkEditInterface {
  bibliographyId: number
  rows: AutoOrderTableItemRow[]
  onUpdated: () => void
}

@Component({
  components: {
    ModalCallNumberEdit,
    AutoOrderTable,
    ModalFooter
  }
})
export default class ModalAutoOrderBulkEdit extends ModalComponentBaseVue {
  @Ref()
  modalCallNumberEdit!: ModalCallNumberEdit

  dialog: boolean = false

  tableBodyHeight: number = 0

  bibliographyId: number = 0

  tableItem: AutoOrderTableItem = defaultAutoOrderTableItem()

  updatedCallback = () => {}

  open(params: ModalAutoOrderBulkEditInterface): void {
    this.bibliographyId = params.bibliographyId

    this.tableItem = Object.assign(defaultAutoOrderTableItem(), {
      rows: cloneDeep(params.rows)
    })
    this.updatedCallback = params.onUpdated
    this.dialog = true

    window.addEventListener('resize', this.calculateTableHeight)
    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.bibliographyId = 0
    this.tableItem = defaultAutoOrderTableItem()
    this.updatedCallback = () => {}
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  // ダイアログ縦幅を固定としている為、計算方法が他と違う点に注意
  calculateTableHeight(): void {
    this.tableBodyHeight = 0
    this.$nextTick(
      () => (this.tableBodyHeight = this.calculateTableHeightBase())
    )
  }

  openModalCallNumberEdit(index: number): void {
    this.modalCallNumberEdit.open({
      editItem: {
        mark: this.tableItem.sortedRows()[index].mark.input,
        ndc: this.tableItem.sortedRows()[index].ndc.input,
        book: this.tableItem.sortedRows()[index].book.input,
        sub: this.tableItem.sortedRows()[index].sub.input
      },
      onClickReflect: (item: CallNumberEditItem) => {
        this.tableItem.sortedRows()[index].mark.input = item.mark
        this.tableItem.sortedRows()[index].ndc.input = item.ndc
        this.tableItem.sortedRows()[index].book.input = item.book
        this.tableItem.sortedRows()[index].sub.input = item.sub
      }
    })
  }

  async update(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographySetApi.updateAutoOrderInfo({
        id: this.bibliographyId,
        autoOrders: this.tableItem.rows.map(row => ({
          orderBranchCode: row.orderBranchCode.code,
          orderNumber: !isNaN(Number(row.orderNumber.input))
            ? Number(row.orderNumber.input)
            : 0,
          traderCode: row.traderCode.input,
          acceptType: row.acceptType.input,
          buyDepartmentCode: row.buyDepartmentCode.input,
          donatedNumber: !isNaN(Number(row.donatedNumber.input))
            ? Number(row.donatedNumber.input)
            : 0,
          donorCode: row.donorCode.input,
          budgetYear: !isNaN(Number(row.budgetYear.input))
            ? Number(row.budgetYear.input)
            : 0,
          budgetBranchCode: row.budgetBranchCode.input,
          budgetDepartmentCode: row.budgetDepartmentCode.input,
          budgetItem: row.budgetItem.input,
          equipType: row.equipType.input,
          collectionType: row.collectionType.input,
          shelfType: row.shelfType.input,
          handlingType: row.handlingType.input,
          storeType: row.storeType.input,
          storingLimitCode: row.storingLimitCode.input,
          mark: row.mark.input,
          ndc: row.ndc.input,
          book: row.book.input,
          sub: row.sub.input,
          revision: row.revision ?? 0
        }))
      })

      this.updatedCallback()

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          autoOrders: this.tableItem.rows.map(row => ({
            orderNumber: row.orderNumber,
            traderCode: row.traderCode,
            acceptType: row.acceptType,
            buyDepartmentCode: row.buyDepartmentCode,
            donatedNumber: row.donatedNumber,
            donorCode: row.donorCode,
            budgetYear: row.budgetYear,
            budgetBranchCode: row.budgetBranchCode,
            budgetDepartmentCode: row.budgetDepartmentCode,
            budgetItem: row.budgetItem,
            equipType: row.equipType,
            collectionType: row.collectionType,
            shelfType: row.shelfType,
            handlingType: row.handlingType,
            storeType: row.storeType,
            storingLimitCode: row.storingLimitCode,
            mark: row.mark,
            ndc: row.ndc,
            book: row.book,
            sub: row.sub
          }))
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
